import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout";
Vue.use(Router);
const mainRoutes = [
  {
    path: "/",
    name: "index",
    redirect: "/index",
    component: Layout,
    children: [
      {
        path: "/index",
        name: "index",
        component: () => import("@/views/index"),
        meta: {
          title: "首页"
        }
      }, {
        path: "/markTime",
        name: "markTime",
        component: () => import("@/views/index/markTime"),
        meta: {
          title: "时光印记"
        }
      }, {
        path: "/obituary",
        name: "obituary",
        component: () => import("@/views/index/obituary"),
        meta: {
          title: "讣告"
        }
      }, {
        path: "/obituarySp",
        name: "obituary",
        component: () => import("@/views/index/obituarySp"),
        meta: {
          title: "讣告"
        }
      },{
        path: "/obituary1",
        name: "obituary1",
        component: () => import("@/views/index/obituary1"),
        meta: {
          title: "讣告"
        }
      },
      {
        path: "/video-animation",
        name: "VideoAnimation",
        component: () => import("@/views/index/video-animation"),
        meta: {
          title: "视频连线"
        }
      }, {
        path: "/video-animation-h5",
        name: "VideoAnimation",
        component: () => import("@/views/index/video-animation-h5"),
        meta: {
          title: "视频连线"
        }
      },
      {
        path: "/video-animationSeven",
        name: "VideoAnimationSeven",
        component: () => import("@/views/index/video-animationSeven"),
        meta: {
          title: "视频连线(主题7)"
        }
      },
      {
        path: "/farewell",
        name: "farewell",
        component: () => import("@/views/index/farewell"),
        meta: {
          title: "数字告别"
        }
      },
      {
        path: "/libation",
        name: "libation",
        component: () => import("@/views/index/libation"),
        meta: {
          title: "时光追祭"
        }
      },
      {
        path: "/mourning",
        name: "mourning",
        component: () => import("@/views/index/mourning"),
        meta: {
          title: "数字灵堂"
        }
      }
    ]
  },
  {
    path: "/",
    name: "activate",
    redirect: "/activate",
    component: Layout,
    children: [
      {
        path: "/Entrance",
        name: "Entrance",
        component: () => import("@/views/activate/Entrance"),
        meta: {
          title: "ID入口"
        }
      },
      {
        path: "/EntranceMobile",
        name: "EntranceMobile",
        component: () => import("@/views/activate/EntranceMobile"),
        meta: {
          title: "手机号入口"
        }
      },
      {
        path: "/departedList",
        name: "departedList",
        component: () => import("@/views/activate/departedList"),
        meta: {
          title: "列表入口"
        }
      }, {
        path: "/list",
        name: "list",
        component: () => import("@/views/activate/list"),
        meta: {
          title: "功能入口"
        }
      }
    ]
  },

  {
    path: "/mobile",
    name: "mobile",
    component: () => import("@/views/mobile/index"),
    meta: {
      title: "语音连线"
    }
  },

  {
    path: "/mobile-liuyan",
    name: "mobile-liuyan",
    component: () => import("@/views/mobile/index-liuyan"),
    meta: {
      title: "时空留言"
    }
  }
];

// 消除重复跳转警告
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new Router({
  mode: "history", // hash history
  base: __dirname,
  routes: mainRoutes
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;
